module.exports = __webpack_public_path__ + "img/contraception-suivi-ovulation-symptothermie-moonly-app.2239b2a5.svg";